<template>
  <v-container
    :class="{ 'fill-height d-flex align-center flex-wrap': !xs }"
    fluid
  >
    <v-row class="d-flex align-center justify-center">
      <v-col cols="auto">
        <slot />
      </v-col>
    </v-row>
  </v-container>
</template>
<script lang="ts" setup>
import { useDisplay } from 'vuetify'

const { xs } = useDisplay()
</script>
